import { Controller } from "@hotwired/stimulus"

// Controller for OTP input boxes (6 individual digit inputs)
export default class extends Controller {
  static targets = ["digit", "hiddenInput", "submitButton", "container"]

  connect() {
    this.updateHiddenValue()
  }

  handleInput(event) {
    const input = event.target
    const value = input.value

    // Only allow digits
    input.value = value.replace(/[^0-9]/g, '')

    if (input.value.length === 1) {
      // Move to next input
      const index = parseInt(input.dataset.index)
      const nextInput = this.digitTargets[index + 1]
      if (nextInput) {
        nextInput.focus()
      }
    }

    this.updateHiddenValue()
  }

  handleKeydown(event) {
    const input = event.target
    const index = parseInt(input.dataset.index)

    if (event.key === 'Backspace' && input.value === '') {
      // Move to previous input on backspace when empty
      const prevInput = this.digitTargets[index - 1]
      if (prevInput) {
        prevInput.focus()
        prevInput.select()
      }
    } else if (event.key === 'ArrowLeft') {
      const prevInput = this.digitTargets[index - 1]
      if (prevInput) {
        event.preventDefault()
        prevInput.focus()
      }
    } else if (event.key === 'ArrowRight') {
      const nextInput = this.digitTargets[index + 1]
      if (nextInput) {
        event.preventDefault()
        nextInput.focus()
      }
    }
  }

  handlePaste(event) {
    event.preventDefault()
    const pastedData = (event.clipboardData || window.clipboardData).getData('text')
    const digits = pastedData.replace(/[^0-9]/g, '').slice(0, 6)

    // Fill in the digits
    digits.split('').forEach((digit, index) => {
      if (this.digitTargets[index]) {
        this.digitTargets[index].value = digit
      }
    })

    // Focus the last filled input or the next empty one
    const lastIndex = Math.min(digits.length, 5)
    if (this.digitTargets[lastIndex]) {
      this.digitTargets[lastIndex].focus()
    }

    this.updateHiddenValue()
  }

  updateHiddenValue() {
    const code = this.digitTargets.map(input => input.value).join('')

    if (this.hasHiddenInputTarget) {
      this.hiddenInputTarget.value = code
    }

    // Enable/disable submit button based on whether all 6 digits are filled
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = code.length !== 6
    }
  }
}
